/* Heka kiosk 75": ena pot »sestavi, poglej v 3D, pošlji specifikacijo«.
   Načini:  local   = iz lokalnega strežnika (/_kiosk/), konfiguratorji v okvirju prek posrednika s predpomnilnikom
            shopify = skrita stran na heka-interior.si (okvir ni dovoljen: 3D se odpre v novem zavihku)
            file    = odprto neposredno iz mape (brez konfiguratorjev, vse ostalo deluje) */
(() => {
  "use strict";
  const C = window.CONFIG, P = window.PRODUCTS;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const MODE = location.pathname.startsWith("/_kiosk/") ? "local"
    : /heka-interior\.|myshopify\.com/.test(location.hostname) ? "shopify" : "file";
  if (window.KIOSK_OVERRIDES) Object.assign(C, window.KIOSK_OVERRIDES); // npr. na heka-interior.si: brez zanke in zaslonske tipkovnice
  // Način kiosk v temi Shopify (piškotek heka_kiosk=1, vklop z ?kiosk=1): zaslon na dotik z vgrajenim Chromom.
  const KC = MODE === "shopify" && /(?:^|;\s*)heka_kiosk=1(?:;|$)/.test(document.cookie);
  if (KC) Object.assign(C, { keyboard: true, idleSeconds: 120, idleWarnSeconds: 15, attract: C.kioskAttract || ["slides"],
    submit: Object.assign({}, C.submit, { enabled: true, kanal: "Ambient 2026 - kiosk", oznaka: "ambient26", stojnica: "2" }) });
  const PK = "hekaKioskPaket";
  const asset = (p) => (window.KIOSK_ASSETS && window.KIOSK_ASSETS[p]) || p;
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
  };
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4"/></svg>';

  const S = { screen: "home", product: null, paket: KC ? store.get(PK, []) : [], choice: {}, rok: "", online: navigator.onLine, server: false, cfgOk: false, prev: "home" };

  // ---------- osnova ----------
  if (/[?&]kiosk=1/.test(location.search) || /(?:^|;\s*)heka_kiosk=1(?:;|$)/.test(document.cookie)) document.body.classList.add("kiosk");
  if (/[?&]nosend=1/.test(location.search)) C.submit.enabled = false; // preizkus: nič ne gre v trgovino
  $("#logo").innerHTML = window.LOGO_SVG || "hēka";
  $("#a-logo").innerHTML = window.LOGO_SVG || "";
  if (C.offer) { $("#offer-home").textContent = C.offerText; $("#offer-home").hidden = false; }
  document.addEventListener("contextmenu", (e) => e.preventDefault());
  document.addEventListener("gesturestart", (e) => e.preventDefault());

  function toast(msg, ms = 2600) {
    const t = $("#toast"); t.textContent = msg; t.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(() => (t.hidden = true), ms);
  }

  // ---------- začetni zaslon ----------
  $("#tiles").innerHTML = P.map((p, i) => `
    <button class="tile" type="button" data-id="${p.id}" aria-label="${esc(p.name)}, ${esc(p.kind)}">
      <span class="well"><img src="${asset(p.tileImg)}" alt="" class="${p.tileFit === "contain" ? "contain" : ""}"><span class="go">${ARROW}</span></span>
      <span class="meta">
        <span class="num">0${i + 1}</span>
        <span class="nm">${esc(p.name)}</span>
        <span class="kd">${esc(p.kind)}${p.noConfigurator ? "" : " · 3D"}</span>
      </span>
    </button>`).join("");
  $$("#tiles .tile").forEach((b) => b.addEventListener("click", () => openProduct(b.dataset.id)));

  // ---------- zasloni ----------
  function show(name) {
    if (S.screen !== name) S.prev = S.screen;
    S.screen = name;
    $$(".screen").forEach((s) => (s.hidden = s.dataset.screen !== name));
    $("#b-add").hidden = name !== "product" || !!(S.product && S.product.noPaket);
    $("#b-back").hidden = !(name === "form");
    $("#b-send").hidden = name === "thanks";
    $("#b-send").textContent = name === "form" ? "Pošlji" : "Pošlji specifikacijo";
    if (name !== "product") unloadFrame();
    renderPaket();
  }

  function renderPaket() {
    if (KC) store.set(PK, S.paket);
    const n = S.screen === "thanks" ? 0 : S.paket.length;
    $("#b-send").classList.toggle("btn-main", S.screen !== "home" || n > 0);
    $("#b-send").classList.toggle("btn-ghost", S.screen === "home" && n === 0);
    $("#paket").innerHTML = n ? `<b>Paket:</b> ${n} ${n === 1 ? "sestava" : n === 2 ? "sestavi" : n < 5 ? "sestave" : "sestav"}` : "";
  }

  // ---------- izdelek ----------
  const frame = $("#cfg");
  let loadTimer = null;

  function openProduct(id) {
    const p = P.find((x) => x.id === id); if (!p) return;
    if (KC && !p.noConfigurator) { store.set(PK, S.paket); location.href = p.path; return; } // konfigurator na lastni strani teme
    S.product = p; S.choice = {}; S.cfgOk = false;
    $("#s-product").classList.toggle("wide", !!p.wide);
    $("#p-kind").textContent = p.kind;
    $("#p-name").textContent = p.name;
    $("#p-line").textContent = p.line;
    $("#p-hint").innerHTML = p.hint ? `<b>V konfiguratorju</b>${esc(p.hint)}` : "";
    $("#p-facts").innerHTML = facts(p);
    const img = $("#fb-img"); img.src = asset((p.gallery && p.gallery[0]) || p.tileImg); img.className = p.tileFit === "contain" ? "contain" : "";
    $("#open-ext").hidden = !(MODE === "shopify" && !p.noConfigurator);
    show("product");
    if (p.noConfigurator) return showFallback(p, "");
    if (MODE !== "local") return showFallback(p, MODE === "shopify" ? "3D konfigurator se odpre v novem zavihku. Sestavo lahko izberete tudi spodaj." : "3D prikaz ni na voljo. Sestavo izberite spodaj.");
    loadFrame(p);
  }

  function facts(p) { return p.facts.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join(""); }

  async function loadFrame(p) {
    $("#fallback").hidden = true; $("#p-chips").hidden = true; $("#p-facts").hidden = true; $("#p-hint").hidden = false;
    $("#loading").hidden = false; frame.hidden = false;
    let avail = { online: true, cached: false };
    try { avail = await (await fetch("/_kiosk/api/avail?u=" + encodeURIComponent(p.path), { cache: "no-store" })).json(); } catch {}
    if (S.product !== p) return;
    if (!avail.online && !avail.cached) return showFallback(p, "3D prikaz ni na voljo. Sestavo izberite spodaj.");
    clearTimeout(loadTimer);
    loadTimer = setTimeout(() => { if (S.product === p && !S.cfgOk) showFallback(p, "3D prikaz ni na voljo. Sestavo izberite spodaj."); }, 20000);
    frame.onload = () => onFrameLoad(p);
    frame.src = p.path;
  }

  function unloadFrame() {
    clearTimeout(loadTimer);
    frame.onload = null;
    if (frame.getAttribute("src") !== "about:blank") frame.src = "about:blank";
  }

  function onFrameLoad(p) {
    if (S.product !== p || frame.getAttribute("src") === "about:blank") return;
    let doc;
    try { doc = frame.contentDocument; } catch { doc = null; }
    if (doc && doc.URL === "about:blank") return; // nalaganje prazne strani pred konfiguratorjem
    if (!doc || !doc.body) return showFallback(p, "3D prikaz ni na voljo. Sestavo izberite spodaj.");
    const okSel = p.keep ? doc.querySelector(p.keep) : doc.querySelector("#heka-planer, [id*=planer], canvas, main");
    if (!okSel || /too many requests|ni mogoče najti/i.test(doc.title + " " + (doc.body.innerText || "").slice(0, 300))) {
      return showFallback(p, "3D prikaz ni na voljo. Sestavo izberite spodaj.");
    }
    S.cfgOk = true; clearTimeout(loadTimer);
    tameFrame(doc, p);
    $("#loading").hidden = true;
  }

  // Skrije glavo, nogo, pasico piškotkov in klepet; ostane samo konfigurator. Prepreči odhod na druge strani.
  function tameFrame(doc, p) {
    const st = doc.createElement("style");
    st.textContent = `
      [id*="__announcement-bar"],[id*="__header"],[id*="__footer"],[id*="__multicolumn-with-icons"],[id*="__newsletter-popup"],
      [id*="__mobile-dock"],[id*="__cart-drawer"],[id*="__search-drawer"],[id*="__planer_cta"],
      #shopify-pc__banner,.shopify-pc__banner__dialog,#shopify-pc__prefs,#shopify-chat,inbox-online-store-chat,#chat-button,
      .breadcrumbs,nav.breadcrumb,nav.crumb,[aria-label="Breadcrumb"],[aria-label="breadcrumbs"],shop-pay-wallet-button,.shopify-payment-button
      { display:none !important; }
      ${p.keep ? `main .shopify-section:not(${p.keep}) { display:none !important; }` : ""}
      ${p.keep ? "" : 'a[href="/"]{ display:none !important; }'}
      html,body{ overscroll-behavior:none; }
      ${document.body.classList.contains("kiosk") ? "*{cursor:none !important}" : ""}`;
    doc.head.appendChild(st);
    const z = (window.innerWidth > 2400 ? window.innerWidth / 1920 : 1) * (p.zoom || C.frameZoom || 1);
    if (z !== 1) doc.documentElement.style.zoom = String(z);
    const w = frame.contentWindow;
    try { w.open = () => null; } catch {}
    doc.addEventListener("click", (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const ext = /^https?:\/\//.test(href) && !href.includes(location.host);
      if (ext || a.target === "_blank" || /^(mailto|tel):/.test(href) || /\/(cart|checkout|account)/.test(href) || href === "/") { e.preventDefault(); e.stopPropagation(); }
    }, true);
    ["pointerdown", "touchstart", "keydown", "wheel", "input"].forEach((ev) => doc.addEventListener(ev, bump, { passive: true, capture: true }));
    // skrij gumbe, ki vodijo iz kioska (povpraševanje trgovine, nalaganje tlorisa, e-pošta)
    const hideTxt = /^(Pošlji povpraševanje|Naloži tloris|Dodaj v košarico|Materiali plošče)$/;
    $$("button, a", doc).forEach((el) => { if (hideTxt.test((el.textContent || "").trim())) el.style.setProperty("display", "none", "important"); });
    $$("h2, h3, strong, b, div", doc).forEach((el) => { if ((el.textContent || "").trim() === "Uvoz tlorisa") { const card = el.closest("section, article, [class*=card], [class*=box]") || el.parentElement; card.style.setProperty("display", "none", "important"); } });
    const target = p.keep ? doc.querySelector(p.keep) : null;
    if (target) w.scrollTo(0, target.getBoundingClientRect().top + w.scrollY);
  }

  function showFallback(p, note) {
    clearTimeout(loadTimer);
    unloadFrame(); frame.hidden = true;
    $("#loading").hidden = true;
    S.cfgOk = false;
    if (p.noConfigurator) {
      $("#fallback").hidden = false;
      $("#fb-note").textContent = "Izdelamo po meri. Izberite kose, mere dogovorimo za vaš projekt.";
    } else {
      $("#fallback").hidden = false;
      $("#fb-note").textContent = note;
    }
    $("#p-facts").hidden = false; $("#p-hint").hidden = true;
    renderChips(p);
    if (p.wide) $("#s-product").classList.remove("wide");
  }

  function renderChips(p) {
    const box = $("#p-chips");
    box.innerHTML = p.offline.map((g, gi) => `<div class="chip-g"><span>${esc(g.key)}</span><div class="chiprow">${
      g.values.map((v, vi) => `<button class="chip" type="button" data-g="${gi}" data-v="${vi}" aria-pressed="false">${esc(v)}</button>`).join("")}</div></div>`).join("");
    box.hidden = false;
    $$(".chip", box).forEach((b) => b.addEventListener("click", () => {
      const g = p.offline[+b.dataset.g], v = g.values[+b.dataset.v];
      if (g.multi) {
        const cur = new Set(S.choice[g.key] || []);
        cur.has(v) ? cur.delete(v) : cur.add(v);
        S.choice[g.key] = [...cur];
        b.setAttribute("aria-pressed", cur.has(v));
      } else {
        S.choice[g.key] = S.choice[g.key] === v ? undefined : v;
        $$(`.chip[data-g="${b.dataset.g}"]`, box).forEach((x) => x.setAttribute("aria-pressed", x === b && !!S.choice[g.key]));
      }
    }));
  }
  $("#open-ext").addEventListener("click", () => { const p = S.product; if (p) window.open(C.publicBase + p.path, "_blank", "noopener"); });

  // Trenutna sestava: iz konfiguratorja (URL + izbrane možnosti) ali iz izbire brez povezave.
  async function currentItem() {
    const p = S.product; if (!p) return null;
    let path = p.path, summary = "";
    if (S.cfgOk) {
      try {
        const w = frame.contentWindow, d = frame.contentDocument;
        path = w.location.pathname + w.location.search + w.location.hash;
        const parts = [];
        if (p.capture === "corelift") {
          // CoreLift: povzetek iz vrstice »Miza: ...« in povezava iz QR okna konfiguratorja (configURL)
          const sm = d.querySelector('[id$="__main-configurator"] .summary > :first-child');
          if (sm) parts.push(sm.textContent.replace(/\s+/g, " ").replace(/Dodatki:/, " · Dodatki:").trim());
          const btn = d.getElementById("cl3d-ar-btn");
          if (btn) {
            btn.click();
            await new Promise((r) => setTimeout(r, 400));
            const qr = d.getElementById("cl3d-qr"), m = d.getElementById("cl3d-qr-modal");
            if (qr && qr.title && /\?/.test(qr.title)) path = new URL(qr.title, location.href).pathname + new URL(qr.title, location.href).search;
            const x = m && m.querySelector(".qx"); if (x) x.click(); else if (m) m.style.display = "none";
          }
        } else {
          const h1 = d.querySelector("h1");
          if (h1) {
            parts.push(h1.textContent.trim().replace(/\s+/g, " "));
            const nx = h1.nextElementSibling; if (nx && nx.textContent.trim().length < 160) parts.push(nx.textContent.trim().replace(/\s+/g, " "));
          }
          $$('[aria-pressed="true"],[aria-checked="true"],[aria-selected="true"],input:checked', d)
            .map((el) => (el.getAttribute("aria-label") || el.getAttribute("title") || (el.labels && el.labels[0] && el.labels[0].innerText) || el.innerText || el.value || "").trim().replace(/\s*\n\s*/g, " ").replace(/\s+/g, " "))
            .filter((t) => t && t.length < 60 && !/^(3D|Risba|AR)$/i.test(t)).forEach((t) => parts.push(t));
        }
        summary = [...new Set(parts)].slice(0, 8).join(" · ");
      } catch {}
    } else {
      summary = Object.entries(S.choice).filter(([, v]) => v && (!Array.isArray(v) || v.length)).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`).join(" · ");
    }
    const url = C.publicBase + path;
    return { id: "i" + Date.now().toString(36), product: p.id, name: p.name, summary: summary || p.kind, path, url };
  }

  async function addCurrent(silent) {
    const it = await currentItem(); if (!it) return false;
    const dup = S.paket.find((x) => x.url === it.url && x.summary === it.summary);
    if (!dup) S.paket.push(it);
    renderPaket();
    if (!silent) toast(dup ? "Ta sestava je že v paketu." : `${it.name} je v paketu. Dodate lahko še druge izdelke.`);
    return true;
  }

  $("#b-add").addEventListener("click", () => addCurrent(false));
  $("#b-send").addEventListener("click", async () => {
    if (S.screen === "form") return submitForm();
    if (S.screen === "product") await addCurrent(true);
    openForm();
  });
  $("#b-back").addEventListener("click", () => { S.product && S.prev === "product" ? openProduct(S.product.id) : show("home"); });
  $("#b-restart").addEventListener("click", () => resetAll(false));

  // ---------- obrazec ----------
  const ROK = ["do 3 mesece", "3–6 mesecev", "6–12 mesecev", "pozneje", "ni projekta"];
  $("#rok").innerHTML = ROK.map((r) => `<button class="chip" type="button" aria-pressed="false">${r}</button>`).join("");
  $$("#rok .chip").forEach((b) => b.addEventListener("click", () => {
    S.rok = S.rok === b.textContent ? "" : b.textContent;
    $$("#rok .chip").forEach((x) => x.setAttribute("aria-pressed", x.textContent === S.rok));
  }));

  function openForm() {
    renderItems();
    show("form");
    $$(".fld").forEach((f) => f.classList.remove("bad"));
    if (!C.keyboard) $$("#form input").forEach((i) => i.removeAttribute("inputmode"));
    setTimeout(() => $("#f-ime").focus({ preventScroll: true }), 50);
  }
  function renderItems() {
    $("#items").innerHTML = S.paket.map((it, i) => `<li><b>${esc(it.name)}</b><p>${esc(it.summary)}</p><button class="rm" type="button" data-i="${i}">Odstrani</button></li>`).join("");
    $("#items-empty").hidden = S.paket.length > 0;
    $$("#items .rm").forEach((b) => b.addEventListener("click", () => { S.paket.splice(+b.dataset.i, 1); renderItems(); renderPaket(); }));
  }

  // zaslonska tipkovnica
  let active = null, shift = false;
  $$("#form input").forEach((i) => i.addEventListener("focus", () => (active = i)));
  const ROWS = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "⌫"],
    ["q", "w", "e", "r", "t", "z", "u", "i", "o", "p", "š"],
    ["a", "s", "d", "f", "g", "h", "j", "k", "l", "č", "ž"],
    ["⇧", "y", "x", "c", "v", "b", "n", "m", ",", ".", "-"],
    ["@", "_", "␣", ".si", ".com", "Naprej"],
  ];
  function drawKb() {
    if (!C.keyboard) { $("#kb").hidden = true; return; }
    $("#kb").innerHTML = ROWS.map((r) => `<div class="r">${r.map((k) => {
      const cls = k === "␣" ? "w5" : ["⌫", "⇧", ".si", ".com", "Naprej"].includes(k) ? "w2" : "";
      const label = k === "␣" ? "presledek" : k === "⇧" ? "velike" : k === "⌫" ? "briši" : shift && k.length === 1 ? k.toUpperCase() : k;
      return `<button type="button" class="${cls}${k === "⇧" && shift ? " on" : ""}" data-k="${esc(k)}">${esc(label)}</button>`;
    }).join("")}</div>`).join("");
  }
  drawKb();
  $("#kb").addEventListener("pointerdown", (e) => e.preventDefault()); // fokus ostane v polju
  $("#kb").addEventListener("click", (e) => {
    const b = e.target.closest("button"); if (!b) return;
    const k = b.dataset.k;
    if (!active) active = $("#f-ime");
    if (k === "⇧") { shift = !shift; return drawKb(); }
    if (k === "Naprej") {
      const list = $$("#form input"); const i = list.indexOf(active);
      (list[i + 1] || list[0]).focus(); return;
    }
    const v = active.value, a = active.selectionStart ?? v.length, z = active.selectionEnd ?? v.length;
    const autoCap = (active.id === "f-ime" || active.id === "f-podjetje") && (a === 0 || v[a - 1] === " ");
    let ins = k === "␣" ? " " : k.length === 1 && (shift || autoCap) ? k.toUpperCase() : k;
    if (k === "⌫") {
      const s = a === z ? Math.max(0, a - 1) : a;
      active.value = v.slice(0, s) + v.slice(z);
      active.setSelectionRange(s, s);
    } else {
      active.value = v.slice(0, a) + ins + v.slice(z);
      active.setSelectionRange(a + ins.length, a + ins.length);
      if (shift && k.length === 1) { shift = false; drawKb(); }
    }
    active.closest(".fld").classList.remove("bad");
    bump();
  });
  $$("#form input").forEach((i) => i.addEventListener("input", () => i.closest(".fld").classList.remove("bad")));
  $("#form").addEventListener("submit", (e) => { e.preventDefault(); submitForm(); });

  function submitForm() {
    const v = (id) => $("#f-" + id).value.trim();
    const bad = [];
    if (!v("ime")) bad.push("ime");
    if (!v("podjetje")) bad.push("podjetje");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v("email"))) bad.push("email");
    $$(".fld").forEach((f) => f.classList.toggle("bad", bad.includes(f.querySelector("input").name)));
    if (bad.length) { $("#f-" + bad[0]).focus(); return; }
    const lead = {
      id: "k" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      cas: new Date().toISOString(),
      stanje: C.submit.enabled ? "čaka" : "zapisano",
      ime: v("ime"), podjetje: v("podjetje"), email: v("email"), projekt: v("projekt"), rok: S.rok,
      sestava: S.paket.map((it) => `${it.name}: ${it.summary}`),
      povezave: S.paket.map((it) => it.url),
      stojnica: C.submit.stojnica, naprava: C.device,
    };
    saveLead(lead);
    thanks(lead);
    sendLead(lead);
  }

  // ---------- kontakti: shrani lokalno, na disk (strežnik) in pošlji v trgovino ----------
  const LK = "hekaKioskLeads";
  function leads() { return store.get(LK, []); }
  function putLead(l) { const a = leads(); const i = a.findIndex((x) => x.id === l.id); i >= 0 ? (a[i] = l) : a.push(l); store.set(LK, a); diskLead(l); }
  function saveLead(l) { putLead(l); }
  function diskLead(l) {
    if (MODE !== "local") return;
    fetch("/_kiosk/api/lead", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(l) }).catch(() => {});
  }

  async function sendLead(l) {
    if (!C.submit.enabled || MODE === "file" || l.stanje === "poslano") return false;
    const nf = MODE === "shopify" && document.getElementById("spec-contact");
    if (nf) { // pravi obrazec trgovine (CAPTCHA reši Shopify); stran se po oddaji znova naloži s ?contact_posted=true
      const set = (n, v) => { const i = nf.querySelector(`[name="${n}"]`); if (i) i.value = v || ""; };
      set("contact[name]", l.ime); set("contact[email]", l.email); set("contact[Podjetje]", l.podjetje);
      set("contact[Projekt]", l.projekt); set("contact[Rok]", l.rok); set("contact[Sestava]", (l.sestava || []).join("\n"));
      set("contact[Povezave]", (l.povezave || []).join("\n")); set("contact[Kanal]", C.submit.kanal); set("contact[Oznaka]", C.submit.oznaka);
      l.stanje = "oddano (splet)"; putLead(l); store.set("hekaKioskPending", { lead: l, paket: S.paket });
      setTimeout(() => (nf.requestSubmit ? nf.requestSubmit() : nf.submit()), 1500);
      return true;
    }
    const f = new URLSearchParams();
    f.set("form_type", "contact"); f.set("utf8", "✓");
    f.set("contact[name]", l.ime); f.set("contact[email]", l.email);
    f.set("contact[Podjetje]", l.podjetje); f.set("contact[Projekt]", l.projekt || "");
    f.set("contact[Rok]", l.rok || ""); f.set("contact[Sestava]", (l.sestava || []).join("\n") || "brez izbrane sestave");
    f.set("contact[Povezave]", (l.povezave || []).join("\n"));
    f.set("contact[Kanal]", C.submit.kanal); f.set("contact[Oznaka]", C.submit.oznaka);
    f.set("contact[Stojnica]", l.stojnica); f.set("contact[Dan]", l.cas.slice(0, 10)); f.set("contact[ID]", l.id);
    f.set("contact[body]", `${C.submit.oznaka} | ${C.submit.kanal}\nProjekt: ${l.projekt || "-"}\nRok: ${l.rok || "-"}\n` +
      (l.sestava || []).map((s, i) => `${i + 1}. ${s}\n   ${(l.povezave || [])[i] || ""}`).join("\n"));
    try {
      const r = await fetch(C.submit.endpoint, { method: "POST", body: f, credentials: "include", headers: { "Content-Type": "application/x-www-form-urlencoded" } });
      if (r.ok && /contact_posted=true/.test(r.url)) { l.stanje = "poslano"; l.poslano = new Date().toISOString(); putLead(l); return true; }
      if (/challenge/.test(r.url)) { l.stanje = "čaka (preverjanje CAPTCHA)"; putLead(l); return false; }
      l.stanje = "čaka (odziv " + r.status + ")"; putLead(l); return false;
    } catch { l.stanje = "čaka (brez povezave)"; putLead(l); return false; }
  }
  async function sendPending() {
    let n = 0;
    for (const l of leads()) if (l.stanje !== "poslano") { if (await sendLead(l)) n++; await new Promise((r) => setTimeout(r, 1500)); }
    return n;
  }
  setInterval(() => { if (S.online && S.screen !== "form") sendPending(); }, C.submit.retrySeconds * 1000);

  // ---------- hvala + QR ----------
  let thanksTimer = null;
  function thanks(l) {
    const first = l.ime.split(/\s+/)[0];
    $("#t-title").textContent = `Hvala, ${first}.`;
    $("#t-text").textContent = "Specifikacijo smo zapisali. Oglasimo se vam po e\u2011pošti.";
    $("#t-offer").hidden = !C.offer; $("#t-offer").textContent = C.offerText;
    $("#qrs").innerHTML = S.paket.slice(0, 3).map((it) => {
      const u = it.url + (it.url.includes("?") ? "&" : "?") + C.qrUtm;
      return `<div class="qr"><div class="code">${qrSvg(u)}</div><span><b>${esc(it.name)}</b> ${esc(shortSum(it))}<br>Sestava za pisarno. Skenirajte s telefonom.</span></div>`;
    }).join("");
    show("thanks");
    let s = C.thanksSeconds;
    const tick = () => { $("#t-count").textContent = `Začetni zaslon čez ${s} s.`; if (s-- <= 0) resetAll(false); };
    clearInterval(thanksTimer); tick(); thanksTimer = setInterval(tick, 1000);
  }
  function shortSum(it) { return (it.summary || "").replace(/^Miza:\s*/, "").split(" · ").slice(0, 3).join(" · ").slice(0, 60); }
  function qrSvg(text) {
    try { const q = window.qrcode(0, "M"); q.addData(text); q.make(); return q.createSvgTag({ cellSize: 6, margin: 4, scalable: true }); }
    catch { return ""; }
  }

  // ---------- ponastavitev in mirovanje ----------
  function resetAll(toAttract) {
    clearInterval(thanksTimer);
    S.paket = []; S.product = null; if (KC) store.set(PK, []); S.choice = {}; S.rok = ""; S.prev = "home";
    $("#form").reset(); $$("#rok .chip").forEach((x) => x.setAttribute("aria-pressed", "false")); shift = false; drawKb();
    $("#warn").hidden = true; closeAdmin();
    show("home");
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    if (toAttract) startAttract();
  }

  let last = Date.now();
  function bump() { last = Date.now(); if (!$("#warn").hidden) $("#warn").hidden = true; }
  ["pointerdown", "touchstart", "keydown", "wheel", "input"].forEach((ev) => document.addEventListener(ev, bump, { passive: true, capture: true }));
  $("#warn-ok").addEventListener("click", bump);
  setInterval(() => {
    if (!C.idleSeconds || !$("#attract").hidden || !$("#admin").hidden) return;
    const idle = (Date.now() - last) / 1000;
    const left = Math.ceil(C.idleSeconds - idle);
    if (C.idleWarnSeconds && S.screen !== "home" && left <= C.idleWarnSeconds && left > 0) { $("#warn").hidden = false; $("#warn-s").textContent = left; }
    if (idle >= C.idleSeconds) resetAll(!!(C.attract && C.attract.length));
  }, 1000);

  // zanka
  const vid = $("#a-video"), slides = $("#slides");
  slides.innerHTML = P.map((p) => `<div class="slide"><div class="si"><img src="${asset(p.tileImg)}" alt="" class="${p.tileFit === "contain" ? "contain" : ""}"></div>
    <div class="st"><span class="k">${esc(p.kind)}</span><span class="n">${esc(p.name)}</span><span class="l">${esc(p.line)}</span></div></div>`).join("");
  let aStep = 0, aTimer = null, attractAt = 0;
  function startAttract() {
    $("#attract").hidden = false; attractAt = Date.now(); aStep = 0; nextAttract();
  }
  function nextAttract() {
    clearTimeout(aTimer);
    if ($("#attract").hidden) return;
    const seq = (C.attract || ["slides"]);
    const mode = seq[aStep % seq.length]; aStep++;
    if (mode === "video" && C.attractVideo) {
      slides.hidden = true; vid.hidden = false;
      if (!vid.getAttribute("src")) vid.src = asset(C.attractVideo);
      vid.currentTime = 0;
      vid.onended = nextAttract; vid.onerror = () => { vid.hidden = true; nextAttract(); };
      vid.play().catch(() => { aTimer = setTimeout(nextAttract, 3000); });
    } else {
      vid.pause(); vid.hidden = true; slides.hidden = false;
      const all = $$(".slide", slides); let i = 0;
      const step = () => {
        all.forEach((s, j) => s.classList.toggle("on", j === i));
        i++;
        aTimer = setTimeout(i < all.length ? step : () => { all.forEach((s) => s.classList.remove("on")); nextAttract(); }, C.slideSeconds * 1000);
      };
      step();
    }
  }
  function stopAttract() {
    clearTimeout(aTimer); vid.pause(); $("#attract").hidden = true; last = Date.now();
  }
  $("#attract").addEventListener("pointerdown", (e) => { e.preventDefault(); e.stopPropagation(); if (Date.now() - attractAt > 300) stopAttract(); });

  // ---------- povezava ----------
  async function checkNet() {
    let online = navigator.onLine;
    if (MODE === "local") {
      try { const s = await (await fetch("/_kiosk/api/status", { cache: "no-store" })).json(); S.server = true; online = s.online; }
      catch { S.server = false; online = false; }
    }
    S.online = online;
    $("#net").hidden = online || MODE === "file";
  }
  checkNet(); setInterval(checkNet, 10000);
  window.addEventListener("online", checkNet); window.addEventListener("offline", checkNet);

  // ---------- prodajalec: tri tapi v znak, PIN ----------
  let taps = [];
  $("#corner").addEventListener("click", () => {
    const now = Date.now(); taps = taps.filter((t) => now - t < 2000); taps.push(now);
    if (taps.length >= 3) { taps = []; openPin(); }
  });
  function openPin() {
    let pin = "";
    const box = $("#admin-box");
    box.classList.remove("wide");
    const draw = () => {
      box.innerHTML = `<p class="h2">PIN</p><div class="pin-dots">${"•".repeat(pin.length) || "&nbsp;"}</div>
        <div class="pin">${[1, 2, 3, 4, 5, 6, 7, 8, 9, "×", 0, "⌫"].map((k) => `<button type="button" data-k="${k}">${k}</button>`).join("")}</div>`;
      $$(".pin button", box).forEach((b) => b.addEventListener("click", () => {
        const k = b.dataset.k;
        if (k === "×") return closeAdmin();
        if (k === "⌫") pin = pin.slice(0, -1); else pin += k;
        if (pin.length >= C.adminPin.length) { if (pin === C.adminPin) return openAdmin(); pin = ""; toast("Napačen PIN."); }
        draw();
      }));
    };
    draw(); $("#admin").hidden = false;
  }
  function closeAdmin() { $("#admin").hidden = true; }
  async function openAdmin() {
    const box = $("#admin-box"); box.classList.add("wide");
    let srv = [];
    if (MODE === "local") { try { srv = await (await fetch("/_kiosk/api/leads", { cache: "no-store" })).json(); } catch {} }
    const all = mergeLeads(leads(), srv);
    const sent = all.filter((l) => l.stanje === "poslano").length;
    box.innerHTML = `<p class="h2">Kontakti s kioska</p>
      <p class="lead">Skupaj ${all.length}${C.submit.enabled ? `, poslanih v trgovino ${sent}, čaka ${all.length - sent}` : " (pošiljanje v trgovino izklopljeno, kontakti so v CSV)"}. Internet: ${S.online ? "da" : "ne"}. Način: ${MODE}${MODE === "local" ? ", kopija na disku: KIOSK/kontakti/kontakti.csv" : ""}.</p>
      <table class="adm-tbl"><tr><th>Čas</th><th>Ime</th><th>Podjetje</th><th>Stanje</th></tr>${all.slice(-8).reverse().map((l) =>
        `<tr><td>${esc(new Date(l.cas).toLocaleString("sl-SI"))}</td><td>${esc(l.ime)}</td><td>${esc(l.podjetje)}</td><td>${esc(l.stanje)}</td></tr>`).join("")}</table>
      <div class="adm-row">${C.submit.enabled ? '<button class="btn btn-main" id="a-send" type="button">Pošlji čakajoče</button>' : ""}
      <button class="btn btn-ghost" id="a-csv" type="button">Izvozi CSV</button>
      ${MODE === "local" ? '<button class="btn btn-ghost" id="a-warm" type="button">Pripravi za delo brez interneta</button>' : ""}
      <button class="btn btn-ghost" id="a-close" type="button">Zapri</button></div>`;
    $("#a-close").onclick = closeAdmin;
    if ($("#a-warm")) $("#a-warm").onclick = warmCache;
    $("#a-csv").onclick = () => exportCsv(all);
    if ($("#a-send")) $("#a-send").onclick = async () => { toast("Pošiljam ..."); const n = await sendPending(); toast(`Poslanih: ${n}.`); openAdmin(); };
  }
  // Priprava predpomnilnika: okvir obišče vse strani konfiguratorjev (dekorji, tipi), da delujejo brez interneta.
  async function warmCache() {
    closeAdmin();
    if (!S.online) return toast("Za pripravo je potrebna povezava.");
    const list = window.WARM_URLS || [];
    S.product = { id: "warm", wide: true }; show("product");
    $("#s-product").classList.add("wide"); $("#fallback").hidden = true; frame.hidden = false; $("#loading").hidden = true;
    const isCached = async (u) => { try { return (await (await fetch("/_kiosk/api/avail?u=" + encodeURIComponent(u), { cache: "no-store" })).json()).exact; } catch { return false; } };
    let missing = list.slice();
    for (let pass = 1; pass <= 3 && missing.length; pass++) {
      for (let i = 0; i < missing.length; i++) {
        if (S.product.id !== "warm") return;
        if (await isCached(missing[i])) continue;
        toast(`Priprava ${pass}. krog: ${i + 1}/${missing.length}`, 20000);
        await new Promise((r) => { frame.onload = () => setTimeout(r, 7000); frame.src = missing[i]; setTimeout(r, 25000); });
        await new Promise((r) => setTimeout(r, 5000)); // Shopify omejuje število zahtev
        last = Date.now();
      }
      const left = [];
      for (const u of missing) if (!(await isCached(u))) left.push(u);
      missing = left;
    }
    window.__warmMissing = missing;
    frame.onload = null;
    toast(missing.length ? `Pripravljeno, manjka ${missing.length} strani (Shopify omejitev). Ponovi čez nekaj minut.` : "Pripravljeno. Konfiguratorji delujejo tudi brez interneta.", 8000);
    resetAll(false);
  }
  window.__warm = warmCache;

  function mergeLeads(a, b) { const m = new Map(); [...b, ...a].forEach((l) => m.set(l.id, { ...(m.get(l.id) || {}), ...l })); return [...m.values()].sort((x, y) => x.cas.localeCompare(y.cas)); }
  function exportCsv(all) {
    const cols = ["id", "cas", "stanje", "ime", "podjetje", "email", "projekt", "rok", "sestava", "povezave", "stojnica", "naprava"];
    const cell = (v) => { v = Array.isArray(v) ? v.join(" | ") : v == null ? "" : String(v); return /[",;\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; };
    const csv = "﻿" + cols.join(";") + "\n" + all.map((l) => cols.map((c) => cell(l[c])).join(";")).join("\n") + "\n";
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
    a.download = `heka-kiosk-kontakti-${new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-")}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    toast("CSV je v mapi Prenosi.");
  }

  // test: ?screen=form|thanks|attract (za posnetke)
  const q = new URLSearchParams(location.search);
  window.__kiosk = { S, openProduct, openForm, resetAll, startAttract, stopAttract, addCurrent, leads, sendPending, showFallback: (id) => showFallback(P.find((p) => p.id === id), "3D prikaz ni na voljo. Sestavo izberite spodaj.") };
  show("home");
  const pend = store.get("hekaKioskPending", null);
  if (pend && (window.KIOSK_POSTED || /contact_posted=true/.test(location.search))) { // vrnitev po oddaji obrazca trgovine
    store.set("hekaKioskPending", null); S.paket = pend.paket || []; thanks(pend.lead);
  } else if (q.get("form") === "1") openForm();
  if (q.get("attract") === "1") startAttract();
})();
